import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PlanDefaultValues, PlanModel } from 'src/app/components/participants/plans/plan';
import { ApplicationRoles } from 'src/app/components/users/user-roles';
import { AuthService } from 'src/app/services/auth.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { PlanService } from 'src/app/services/plan.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-add-plan',
    templateUrl: './add-plan.component.html',
    styleUrls: ['./add-plan.component.scss'],
    standalone: false
})
export class AddPlanComponent {
  planDetails: PlanModel = PlanDefaultValues();
  participantClassByRole: string = '';
  translations: any;
  llttfPage:boolean = false;

  constructor(private _planservice: PlanService,
    private toastservice: ToastService,
    private router: Router,
    private authservice: AuthService,
    private translationService: TranslationService,
    private themeService: ParticipantThemeService
  ) { }

  ngOnInit() {
    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;

    this.translationService.getTranslation().subscribe({
      next: (translations) => {
       this.translations = translations;
      }
    });
  }

  createPlan() {
    this._planservice.createPlan(this.planDetails).subscribe({
      next: (response) => {
        this.toastservice.showMessage("Plan created successfully");
        this.router.navigateByUrl('/dashboard-participant')
      }
    });
  }

}
